import moment from 'moment-timezone';
import { ADDRESS_TYPE, DATE_WITH_FORMAT_TYPE, DELIVERY_TYPE_TYPE, DELIVERY_TYPE_VALUES, EMAIL_TYPE, MAP_TYPE, NEW_ADDRESS_TYPE, NUMBER_STRING_TYPE, PAY_LINK_CREATE_TYPE, PAY_LINK_TYPE, PAYMENT_TYPE_TYPE, PAYMENT_TYPE_VALUES, PHONE_TYPE, PRICE_TYPE, REQUEST_NUMBER_TYPE, STATUS_TYPE, SUBMIT_TYPE_TYPE, SUBMIT_TYPE_VALUES, TEXT_TYPE } from '../../../../../../assets/utils/constants';
import { formatAddress, formatNewAddress, getAvailableStatuses, hasPermission, parsePermissions, parsePhone, parsePrice, parseRequestNumber, parseStatus } from '../../../../../../assets/utils/utils';

import { motion } from 'framer-motion'
import './InfoBox.css';
import { useContext, useEffect, useRef, useState } from 'react';
import SubmitActionPopup from '../../../../SubmitActionPopup/SubmitActionPopup';
import mainApi from '../../../../../../assets/api/MainApi';
import { UserContext } from '../../../../../../assets/contexts/userContext';
import { OrderConfigContext } from '../../../../../../assets/contexts/orderConfigContext';
import { PERMISSIONS, RBAC_ORDERS } from '../../../../../../assets/utils/permissions_rbac';
import AddressMap from '../../../../Settings/Integrations/Delivery/AddressMap/AddressMap';

const EXEMPLE_CONFIG = {
    payments: {
        "manager": {
            "limit": "1000000",
            "statuses": [
                "new",
                "in_work",
                "paid",
                "ready",
                "done",
                "cancelled"
            ],
            "status_changes": {
                "in_work": [
                    "new"
                ],
                "paid": [
                    "new",
                    "in_work"
                ],
                "ready": [
                    "new",
                    "in_work",
                    "paid"
                ],
                "cancelled": [
                    "new",
                    "in_work",
                    "paid",
                    "ready"
                ],
                "done": [
                    "new",
                    "in_work",
                    "paid",
                    "ready"
                ]
            }
        },
        "yookassa": {
            "limit": "250000",
            "statuses": [
                "new",
                "paid",
                "in_work",
                "ready",
                "done",
                "cancelled"
            ],
            "status_changes": {
                "in_work": [
                    "paid"
                ],
                "ready": [
                    "in_work"
                ],
                "cancelled": [
                    "paid",
                    "in_work",
                    "ready"
                ],
                "done": [
                    "in_work",
                    "ready"
                ]
            }
        },
    },
}

const dropdownVariants = {
    open: {
        clipPath: "inset(0% 0% 0% 0% round 8px)",
        transition: {
            type: "spring",
            bounce: 0,
            duration: 0.5,
            delayChildren: 0.2,
            staggerChildren: 0.05,
        },
    },
    closed: {
        clipPath: "inset(0 90% 90% 10% round 8px)",
        transition: {
            type: "spring",
            bounce: 0,
            duration: 0.3,
        },
    },
};

const itemVariants = {
    open: {
        opacity: 1,
        y: 0,
        transition: { type: "spring", stiffness: 300, damping: 24 },
    },
    closed: { opacity: 0, y: 20, transition: { duration: 0.2 } },
};

function InfoBox({
    title,
    data_map,
    data,
    key_name,
    setOrder
}) {
    const [ymap, setYmap] = useState()
    const config = useContext(OrderConfigContext)
    const [isSelectOpen, setSelectOpen] = useState(false)
    const dropdownRef = useRef(null)
    const { user } = useContext(UserContext);
    const hasEditPermission = hasPermission(parsePermissions(user), [RBAC_ORDERS[PERMISSIONS.EDIT]])


    console.log({ config })
    const AVALIBLE_STATUSES = data && key_name === 'main_data' && config ? getAvailableStatuses({
        config: config,
        order: data,
    })[data.status] : null

    const [isSubmitOpen, setSubmitOpen] = useState(false)
    const [selectedStatus, setSelectedStatus] = useState(undefined)

    function handleSelectStatus(status) {
        setSelectedStatus(status)
        setSubmitOpen(true)
    }

    function handleCloseSubmit() {
        setSelectOpen(false)
        setSubmitOpen(false)
        setTimeout(() => {
            setSelectedStatus(undefined)
        }, 300);
    }

    const [isSubmitPreloader, setSubmitPreloader] = useState(false)

    function hendleSubmit() {
        if (isSubmitPreloader || !user) return

        const shop_id = user.default_shop._id;
        setSubmitPreloader(true)
        mainApi.editStatus({ shop_id, _id: data._id, status: selectedStatus, payment_type: data.payment_type })
            .then((res) => {
                console.log(res)
                setOrder(prevValue => ({
                    ...prevValue,
                    status: selectedStatus,
                }))
                handleCloseSubmit()
            })
            .catch((err) => {
                console.log(err)
            })
            .finally(() => {
                setSubmitPreloader(false)
            })
    }

    useEffect(() => {
        function handleOutsideClickClose(evt) {
            if (
                isSelectOpen &&
                dropdownRef.current &&
                !dropdownRef.current.contains(evt.target)
            ) {
                setSelectOpen(false)
                setSubmitOpen(false)
                setTimeout(() => {
                    setSelectedStatus(undefined)
                }, 300);
            }
        }

        document.addEventListener("mousedown", handleOutsideClickClose);
        return () => {
            document.removeEventListener("mousedown", handleOutsideClickClose);
        };
    });

    const [isCopied, setCopied] = useState(false)


    function copyToClipboard(text) {

        var textArea = document.createElement("textarea");
        textArea.style.position = 'fixed';
        textArea.style.top = 0;
        textArea.style.left = 0;
        textArea.style.width = '2em';
        textArea.style.height = '2em';
        textArea.style.padding = 0;
        textArea.style.border = 'none';
        textArea.style.outline = 'none';
        textArea.style.boxShadow = 'none';
        textArea.style.background = 'transparent';
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();

        try {
            var successful = document.execCommand('copy');
            var msg = successful ? 'successful' : 'unsuccessful';

            setCopied(true)
            setTimeout(() => {
                setCopied(false)
            }, 1500);
            console.log('Copying text command was ' + msg);
        } catch (err) {
            console.log('Oops, unable to copy');
        }

        document.body.removeChild(textArea);
    }

    const [isSubmitCreatePayLinkOpen, setSubmitCreatePayLinkOpen] = useState(false)
    const [isSubmitPayLinkPreloader, setSubmitPayLinkPreloader] = useState(false)

    function handleSubmitCreatePayLinkOpen() {
        setSubmitCreatePayLinkOpen(true)
    }

    function handleSubmitCreatePayLink() {
        if (isSubmitPreloader || !user) return

        const shop_id = user.default_shop._id;
        setSubmitPayLinkPreloader(true)
        mainApi.editPaymentType({ shop_id, _id: data._id, payment_type: 'cryptocloud' })
            .then((res) => {
                console.log(res)
                setOrder(prevValue => ({
                    ...prevValue,
                    url: res.url,
                    payment_type: 'cryptocloud',
                }))
                handleCloseSubmitCreatePayLink()
            })
            .catch((err) => {
                console.log(err)
            })
            .finally(() => {
                setSubmitPayLinkPreloader(false)
            })
    }

    function handleCloseSubmitCreatePayLink() {
        setSubmitCreatePayLinkOpen(false)
    }
    return (
        <div className='info-box'>
            {data && key_name === 'main_data' && hasEditPermission && AVALIBLE_STATUSES && AVALIBLE_STATUSES.length > 0 ?
                <SubmitActionPopup isSubmitPreloader={isSubmitPreloader} hendleSubmit={hendleSubmit} hendleClose={handleCloseSubmit} isOpen={isSubmitOpen} text={selectedStatus ? `Вы уверены что хотите изменить статус заказа ${parseRequestNumber(data.ai_id)} на "${parseStatus(selectedStatus)}"` : ''} submitText={'Изменить статус'} cencelText={'Отменить'} />
                :
                null
            }
            {data && key_name === 'client_data' && hasEditPermission ?
                <SubmitActionPopup isSubmitPreloader={isSubmitPayLinkPreloader} hendleSubmit={handleSubmitCreatePayLink} hendleClose={handleCloseSubmitCreatePayLink} isOpen={isSubmitCreatePayLinkOpen} text={`Вы&nbsp;уверены что хотите создать ссылку на&nbsp;оплату для заказа ${parseRequestNumber(data.ai_id)}? <br/><br/>После создания ссылки изменить состав заказа будет невозможно.`} submitText={'Создать ссылку'} cencelText={'Отменить'} />
                :
                null
            }
            <p className='info-box__title'>{title}</p>
            <div className='info-box__infos'>
                {data_map && data_map.length > 0 ?
                    data_map.map((item, i) => (
                        <div className={`info-box__info ${item.type === MAP_TYPE ? 'info-box__info_type_map' : ''}`} key={`${key_name}_info-box__info_${i}`}>
                            <p className='info-box__info-title'>{item.title}</p>
                            {item.type === TEXT_TYPE ?
                                <p className='info-box__info-value'>{data[item.key] ? data[item.key] : '-'}</p>
                                :
                                null
                            }
                            {item.type === PHONE_TYPE ?
                                <a className='info-box__info-value info-box__info-value_link' rel="noreferrer" href={`tel:+${data[item.key]}`} >{parsePhone(data[item.key])}</a>
                                :
                                null
                            }
                            {item.type === EMAIL_TYPE ?
                                <a className='info-box__info-value info-box__info-value_link' rel="noreferrer" href={`mailto:${data[item.key]}`} >{data[item.key]}</a>
                                :
                                null
                            }
                            {item.type === SUBMIT_TYPE_TYPE ?
                                <p className='info-box__info-value'>{SUBMIT_TYPE_VALUES[data[item.key]]}</p>
                                :
                                null
                            }
                            {item.type === PAYMENT_TYPE_TYPE ?
                                <p className='info-box__info-value'>{PAYMENT_TYPE_VALUES[data[item.key]]}</p>
                                :
                                null
                            }
                            {
                                item.type === ADDRESS_TYPE ?
                                    <p className='info-box__info-value'>{formatAddress(data[item.key])}</p>
                                    :
                                    null
                            }
                            {
                                item.type === NEW_ADDRESS_TYPE ?
                                    <p className='info-box__info-value'>{formatNewAddress(data[item.key])}</p>
                                    :
                                    null
                            }
                            {item.type === DELIVERY_TYPE_TYPE ?
                                <p className='info-box__info-value'>{DELIVERY_TYPE_VALUES[data[item.key]]}</p>
                                :
                                null
                            }
                            {item.type === REQUEST_NUMBER_TYPE ?
                                <p className='info-box__info-value'>{parseRequestNumber(data[item.key])}</p>
                                :
                                null
                            }

                            {item.type === DATE_WITH_FORMAT_TYPE ?
                                <p className='info-box__info-value'>{moment(data[item.key]).format(item.format)}</p>
                                :
                                null
                            }

                            {item.type === PRICE_TYPE ?
                                <p className='info-box__info-value'>{parsePrice(data[item.key], 'USD')}</p>
                                :
                                null
                            }
                            {item.type === NUMBER_STRING_TYPE ?
                                <p className='info-box__info-value'>{Number(data[item.key]).toLocaleString()}</p>
                                :
                                null
                            }
                            {item.type === PAY_LINK_TYPE ?
                                <button className='info-box__info-pay-link' type='button' onClick={() => {
                                    copyToClipboard(data[item.key])
                                }}>
                                    {isCopied ? 'Скопированно' : 'Cкопировать ссылку'}
                                </button>
                                :
                                null
                            }
                            {item.type === PAY_LINK_CREATE_TYPE ?
                                <button className='info-box__info-pay-link' type='button' onClick={() => {
                                    handleSubmitCreatePayLinkOpen()
                                }}>
                                    Cоздать ссылку USDT
                                </button>
                                :
                                null}
                            {item.type === MAP_TYPE ?
                                <AddressMap
                                    className={'info-box__map'}
                                    location={{
                                        center: data[item.key], // data[item.key]
                                        zoom: 11,
                                    }}
                                    setYmap={setYmap}
                                    disabled={false}
                                />
                                :
                                null
                            }
                            {item.type === STATUS_TYPE ?
                                <div className='info-box__status'>
                                    <div className='info-box__status-current'>
                                        <p className='info-box__info-value'>{parseStatus(data[item.key])}</p>
                                        {AVALIBLE_STATUSES && AVALIBLE_STATUSES.length > 0 && data[item.key] !== 'cancelled' && hasEditPermission ?
                                            <button className='info-box__btn' type='button' onClick={() => {
                                                setSelectOpen(prevValue => !prevValue)
                                            }}>
                                                Изменить...
                                            </button>
                                            :
                                            null
                                        }
                                    </div>
                                    {hasEditPermission ?
                                        <div
                                            className={`platform-input__dropdown ${isSelectOpen ? "platform-input__dropdown_opened" : ""
                                                }`}
                                            ref={dropdownRef}
                                        >
                                            <motion.div
                                                className="platform-input__box-with-dropdown"
                                                initial={false}
                                                animate={isSelectOpen ? "open" : "closed"}
                                            >
                                                <motion.div
                                                    variants={dropdownVariants}
                                                    style={{ pointerEvents: isSelectOpen ? "auto" : "none" }}
                                                    className="platform-input__dropdown-container"
                                                >
                                                    <ul className="platform-input__dropdown-list">

                                                        {AVALIBLE_STATUSES && AVALIBLE_STATUSES.length > 0 ?
                                                            AVALIBLE_STATUSES.map((item, i) => (
                                                                <motion.li
                                                                    className={`platform-input_dropdown-item `}
                                                                    key={`info-box__status-drop-item-${i}`}
                                                                    variants={itemVariants}
                                                                >
                                                                    <button
                                                                        className="platform-input_dropdown-btn"
                                                                        type="button"
                                                                        onClick={() => {
                                                                            // console.log(item, value);
                                                                            setSelectOpen(false);
                                                                            handleSelectStatus(item)
                                                                            // handleChange({
                                                                            //     target: {
                                                                            //         value: item,
                                                                            //         name: name,
                                                                            //     },
                                                                            // });
                                                                        }}
                                                                    >
                                                                        {parseStatus(item)}
                                                                    </button>

                                                                </motion.li>
                                                            ))
                                                            :
                                                            null
                                                        }
                                                    </ul>
                                                </motion.div>
                                            </motion.div>
                                        </div> : null}
                                </div>

                                :
                                null
                            }
                        </div>
                    ))
                    :
                    null
                }
            </div>
        </div>
    );
}

export default InfoBox